import React, { useEffect, useState } from "react";
import { useTheme } from "./ThemeContext";
import axios from "axios";
import { Autocomplete, Box, Chip } from "@mui/material";
import { StyledTextField } from "../utils/Utils";

export const TickerSearch = ({ ticker, setTicker, label = "Ticker Symbol", placeholder = "Search for ticker (e.g., AAPL, BTC, SPY)" }) => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const { theme } = useTheme();

  useEffect(() => {
    if (query.length > 0) {
      const fetchData = async () => {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_SC_API_BASE_URL}/api/tickers/search?query=${query}&limit=10`
          );
          setResults(response.data);
        } catch (err) {
          console.error("Error fetching tickers:", err);
        }
      };
      fetchData();
    } else {
      setResults([]);
    }
  }, [query]);

  const handleSelect = (event, value) => {
    if (value) {
      setTicker(value.symbol);
      setQuery(""); // Clear the text input
    }
  };

  const handleInputChange = (event, newInputValue) => {
    setQuery(newInputValue);
    // Also allow manual entry
    if (event && event.type === "change") {
      setTicker(newInputValue);
    }
  };

  const getAssetTypeColor = (assetType) => {
    switch (assetType) {
      case "STOCK":
        return theme.palette.success.main;
      case "CRYPTO":
        return theme.palette.warning.main;
      case "ETF":
        return theme.palette.info.main;
      case "INDEX":
        return theme.palette.secondary.main;
      default:
        return theme.palette.primary.main;
    }
  };

  return (
    <Box>
      <Autocomplete
        freeSolo
        options={results}
        getOptionLabel={(option) => {
          if (typeof option === "string") return option;
          return `${option.symbol} - ${option.name}`;
        }}
        onInputChange={handleInputChange}
        onChange={handleSelect}
        inputValue={query || ticker}
        renderOption={(props, option) => (
          <Box
            component="li"
            {...props}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px 16px",
            }}
          >
            <Box>
              <Box sx={{ fontWeight: 600, color: theme.palette.text.primary }}>
                {option.symbol}
              </Box>
              <Box
                sx={{
                  fontSize: "0.875rem",
                  color: theme.palette.text.secondary,
                }}
              >
                {option.name}
              </Box>
            </Box>
            <Chip
              label={option.assetType}
              size="small"
              sx={{
                backgroundColor: getAssetTypeColor(option.assetType),
                color: theme.palette.getContrastText(
                  getAssetTypeColor(option.assetType)
                ),
                fontWeight: 600,
                fontSize: "0.7rem",
              }}
            />
          </Box>
        )}
        renderInput={(params) => (
          <StyledTextField
            {...params}
            label={label}
            variant="outlined"
            fullWidth
            placeholder={placeholder}
            InputLabelProps={{
              style: { color: theme.palette.secondary.main },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: theme.palette.primary.main,
                },
                "&:hover fieldset": {
                  borderColor: theme.palette.primary.main,
                },
                "&.Mui-focused fieldset": {
                  borderColor: theme.palette.primary.main,
                },
              },
              "& .MuiInputBase-input": {
                color: theme.palette.secondary.main,
                backgroundColor: `${theme.palette.background.default} !important`,
              },
            }}
          />
        )}
      />
    </Box>
  );
};

export default TickerSearch;
